@keyframes slide {
	from {
		transform: var(--origin);
		opacity: 0;
	}

	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.popover {
	--arrow-offset: var(--lp-size-2);

	isolation: isolate;
	border-radius: var(--lp-border-radius-medium);
	color: var(--lp-color-text-ui-primary-base);
	background-color: var(--lp-color-bg-overlay-secondary);
	box-shadow:
		0px 0px 1px 0px var(--lp-color-shadow-ui-secondary),
		0px 0px 4px 0px var(--lp-color-shadow-ui-secondary),
		0px 4px 8px 0px var(--lp-color-shadow-ui-secondary),
		0px 2px 12px 0px var(--lp-color-shadow-ui-secondary);
	transform: translate3d(0, 0, 0);
	will-change: transform, opacity;

	& [slot='title'] {
		font: var(--lp-text-heading-2-medium);
	}

	& .arrow svg {
		display: block;
		fill: var(--lp-color-bg-overlay-secondary);
		stroke: light-dark(var(--lp-color-border-ui-secondary), transparent);
		stroke-width: 1px;
	}

	&[data-trigger='DialogTrigger'] {
		padding: var(--lp-spacing-300);
	}

	&[data-trigger='ComboBoxDialog'] {
		padding: var(--lp-spacing-300);
	}

	&:is([data-trigger='DatePicker'], [data-trigger='DateRangePicker']) {
		padding: var(--lp-spacing-600);
	}

	&[data-placement='top'] {
		--origin: translateY(4px);

		&:has(.arrow) {
			margin-bottom: var(--arrow-offset);
		}
	}

	&[data-placement='bottom'] {
		--origin: translateY(-4px);

		& .arrow svg {
			transform: rotate(180deg);
		}

		&:has(.arrow) {
			margin-top: var(--arrow-offset);
		}
	}

	&[data-placement='right'] {
		--origin: translateX(-4px);

		& .arrow svg {
			transform: rotate(90deg);
		}

		&:has(.arrow) {
			margin-left: var(--arrow-offset);
		}
	}

	&[data-placement='left'] {
		--origin: translateX(4px);

		& .arrow svg {
			transform: rotate(-90deg);
		}

		&:has(.arrow) {
			margin-right: var(--arrow-offset);
		}
	}

	&:not(:is([data-trigger='MenuTrigger'], [data-trigger='SubmenuTrigger']), :has(.arrow)) {
		overflow: auto;
	}

	@media (prefers-reduced-motion: no-preference) {
		&[data-entering] {
			animation-name: slide;
			animation-duration: var(--lp-duration-200);
			animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
		}
	}
}

.default {
	&[data-trigger='DialogTrigger'] {
		min-width: var(--lp-size-192);
	}

	&[data-trigger='MenuTrigger'],
	&[data-trigger='SubmenuTrigger'] {
		min-width: var(--lp-size-192);
		max-width: var(--lp-size-400);
	}

	&[data-trigger='Select'] {
		min-width: var(--trigger-width);
	}

	&[data-trigger='ComboBox'] {
		min-width: var(--trigger-width);
	}
}

.trigger {
	&[data-trigger] {
		width: var(--trigger-width);
	}
}
